import React from 'react';
import PropTypes from 'prop-types';
import {
  LuBuilding2, LuCalendarCheck, LuCalendarClock, LuCalendarDays, LuScrollText, LuSignature, LuFolderKanban, LuGavel,
  LuHash, LuLandmark, LuReceipt, LuRepeat, LuText, LuUserRound, LuWallet,
} from 'react-icons/lu';
import DetailPane from '../../../../components/data/DetailPane';
import useProjectFinanceText from '../projectFinanceText';
import { PF_COLUMNS, phaseGroupOf } from '../projectFinanceColumns';
import { PHASE_GRADIENT, PhaseBadge, useProjectCellText } from './ProjectFinanceCell';

// Paneldeki alanlar (kısa başlık ve aşama kimlikte gösterilir)
const DETAIL_FIELDS = [
  ['titleLong', LuText],
  ['customer', LuBuilding2],
  ['projectDate', LuCalendarDays],
  ['projectDueDate', LuCalendarClock],
  ['firstInvoiceDate', LuReceipt],
  ['paymentFrequency', LuRepeat],
  ['projectDepartment', LuLandmark],
  ['projectCentersType', LuBuilding2],
  ['coordinatorAcademician', LuUserRound],
  ['protocolNumber', LuHash],
  ['ethicsCommitteeDate', LuCalendarCheck],
  ['ethicsCommitteeNumber', LuGavel],
  ['ethicsCommitteePlace', LuGavel],
  ['sbFirstApprovalDate', LuCalendarCheck],
  ['sbFirstApprovalNumber', LuSignature],
  ['sbProjectNumber', LuHash],
];

/**
 * The selected project: Bütçe and Sözleşmeler (the old action bar) and all
 * of its fields. Docked beside the table on wide screens, a drawer otherwise.
 */
const ProjectFinanceDetailPane = ({ docked, height, project, position, onPrev, onNext, onClose, onBudget, onContracts }) => {
  const { label } = useProjectFinanceText();
  const cellText = useProjectCellText();
  const paneLabel = label('panel.label');

  if (!project) return <DetailPane docked={docked} height={height} open={false} label={paneLabel} onClose={onClose} />;

  return (
    <DetailPane
      docked={docked}
      height={height}
      open
      label={paneLabel}
      heading={label('panel.heading')}
      position={position}
      contentKey={project.id}
      identity={{
        avatar: <LuFolderKanban aria-hidden="true" className="tw-h-7 tw-w-7" />,
        gradient: PHASE_GRADIENT[phaseGroupOf(project.projectPhase)],
        title: project.titleShort || label('panel.untitled'),
        subtitle: project.customer || undefined,
        badges: <PhaseBadge phase={project.projectPhase} />,
      }}
      actions={[
        { key: 'budget', label: label('panel.budget'), icon: LuWallet, tint: 'emerald', onClick: onBudget },
        { key: 'contracts', label: label('panel.contracts'), icon: LuScrollText, tint: 'violet', onClick: onContracts },
      ]}
      details={DETAIL_FIELDS.map(([key, icon]) => ({
        key,
        icon,
        label: label(`columns.${key}`),
        value: cellText(project, key, PF_COLUMNS[key].type) || '-',
      }))}
      onPrev={onPrev}
      onNext={onNext}
      onClose={onClose}
    />
  );
};

ProjectFinanceDetailPane.propTypes = {
  docked: PropTypes.bool,
  height: PropTypes.number,
  project: PropTypes.object,
  position: PropTypes.shape({ index: PropTypes.number, total: PropTypes.number }),
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onBudget: PropTypes.func.isRequired,
  onContracts: PropTypes.func.isRequired,
};

export default ProjectFinanceDetailPane;
